(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf-gift-section"] && !window.DesignMode) return;
  try {
    
  function addToCart(elem, type) {
    document.querySelectorAll(elem).forEach(function (elem) {
      elem.onclick = function (e) {
        e.preventDefault();

        // Get the button and loader elements
        var buttonElement = this.querySelector('.button');
        var loaderElement = this.querySelector('.loader');

        // Hide the button and show the loader
        buttonElement.style.display = 'none';
        loaderElement.classList.remove('hide');

        let formData = {
          items: [
            {
              id: elem.getAttribute('data-variant-id'),
              quantity: 1,
            },
          ],
        };
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (json) {
            if (type == 'checkout') {
              window.location.href = '/checkout';
            } else {
              theme.Cart.prototype._onProductAdded();
            }
          })
          .finally(() => {
            // Show the button and hide the loader
            buttonElement.style.display = 'flex';
            loaderElement.classList.add('hide');
          });
      };
    });
  }

  if (document.querySelectorAll('.btn--addtocart').length > 0) {
    addToCart('.btn--addtocart', '');
  }

  if (document.querySelectorAll('.btn--checkoutproduct').length > 0) {
    addToCart('.btn--checkoutproduct', 'checkout');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust_box-content"] && !window.DesignMode) return;
  try {
    
  let swiperInstances = []; // Array to hold swiper instances

  function initCustSliderImageContent() {
    // Check if the window width is less than or equal to 749px (mobile)
    if (window.innerWidth <= 749) {
      var sliders = document.querySelectorAll('[data-js-cust-box-content-slider]');
      if (!sliders.length) return; // Exit if no sliders are found

      sliders.forEach(function (slider, index) {
        if (!swiperInstances[index]) { // Check if swiper instance already exists
          swiperInstances[index] = new Swiper(slider, {
            spaceBetween: 0,
            slidesPerView: 'auto',
            loop: false,
          });
        }
      });
    } else {
      // Destroy swiper instances on desktop
      swiperInstances.forEach(function (swiper) {
        if (swiper) {
          swiper.destroy(true, true); // Destroy the swiper instance
        }
      });
      swiperInstances = []; // Clear the array
    }
  }

  function initScrollToSection() {
    var scrollPosEnd = 0;
    document.querySelectorAll('.cust-box-content__button').forEach(function(element){
      var section_id = element.getAttribute('href');

      // Only add click event if href starts with "#"
      if (section_id.startsWith("#")) {
        element.onclick = function(e){
          e.preventDefault();
          var sectionElem = document.querySelector(section_id);
          if(sectionElem) {
            var scrollDiv;
            scrollDiv = sectionElem.offsetTop;

            scrollPosEnd = scrollDiv - 100;
            window.scrollTo({ top: scrollDiv, behavior: 'smooth' });
          }
        };
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function() {
    initCustSliderImageContent();
    initScrollToSection();

    // Add event listener for window resize
    window.addEventListener("resize", function() {
      // Re-initialize the slider on resize
      initCustSliderImageContent();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust_slider-content"] && !window.DesignMode) return;
  try {
    
  let swiperInstances = []; // Array to hold swiper instances

  function initCustSliderImageContent() {
    // Check if the window width is less than or equal to 749px (mobile)
    if (window.innerWidth <= 749) {
      var sliders = document.querySelectorAll('[data-js-cust-slider-content-slider]');
      if (!sliders.length) return; // Exit if no sliders are found

      sliders.forEach(function (slider, index) {
        if (!swiperInstances[index]) { // Check if swiper instance already exists
          swiperInstances[index] = new Swiper(slider, {
            spaceBetween: 0,
            slidesPerView: 'auto',
            loop: false,
          });
        }
      });
    } else {
      // Destroy swiper instances on desktop
      swiperInstances.forEach(function (swiper) {
        if (swiper) {
          swiper.destroy(true, true); // Destroy the swiper instance
        }
      });
      swiperInstances = []; // Clear the array
    }
  }

  document.addEventListener("DOMContentLoaded", function() {
    initCustSliderImageContent();

    // Add event listener for window resize
    window.addEventListener("resize", function() {
      // Re-initialize the slider on resize
      initCustSliderImageContent();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust_tabs-content-with-table"] && !window.DesignMode) return;
  try {
    
  function initCustTabsContent() {
    const tabLinks = document.querySelectorAll(".cust-tabs-content-table__tab-link");
    const tabContents = document.querySelectorAll(".cust-tabs-content-table__content");

    tabLinks.forEach((link, index) => {
      link.addEventListener("click", () => {
        tabLinks.forEach((link2) => link2.parentNode.classList.remove("active")),
        tabContents.forEach((content) => content.classList.remove("active")),
        link.parentNode.classList.add("active"),
        tabContents[index].classList.add("active");
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function() {
    initCustTabsContent();

    // Add event listener for window resize
    window.addEventListener("resize", function() {
      // Re-initialize the slider on resize
      initCustTabsContent();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust_yt-video"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const thumbnails = document.querySelectorAll('.cust-yt-video__thumbnail');

    thumbnails.forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function (event) {
        const iframeWrapper = thumbnail.parentElement.querySelector('.cust-yt-video__iframe-wrapper');

        if (iframeWrapper) {
          iframeWrapper.classList.remove('hidden');
          void iframeWrapper.offsetWidth;
        }
      });
    });

    const closeButtons = document.querySelectorAll('.close-btn');

    closeButtons.forEach(function (closeButton) {
      closeButton.addEventListener('click', function (event) {
        const iframeWrapper = closeButton.parentElement;
        const iframe = iframeWrapper.querySelector('.cust-yt-video__iframe');

        if (iframeWrapper) {
          iframeWrapper.classList.add('hidden');
          if (iframe) {
            const src = iframe.src;
            iframe.src = src;
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m4-member-custom-section"] && !window.DesignMode) return;
  try {
    
      if(document.querySelectorAll('.open_info').length > 0 && window.innerWidth < 768){
        document.querySelectorAll('.open_info').forEach(function(element){
            var left_offset = element.offsetLeft;
            var top_offset = element.offsetTop;
            console.log(left_offset);
            console.log(top_offset);
            if(left_offset > window.innerWidth / 2){
              element.querySelector('.info_content').classList.add('align_right');
              element.querySelector('.info_content').style.setProperty('--right-offset', left_offset - 230 + 'px');
            }
            element.querySelector('.info_content').style.setProperty('--left-offset', left_offset + 'px');
            element.querySelector('.info_content').style.setProperty('--top-offset', top_offset + 'px');
        });
      }
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["river-generator"]) return;
  try {
    
    const capSwiper = new Swiper('.capacity-swiper-container', {
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
    const swiper = new Swiper('.river-series-swiper-container', {
        autoplay: {
            delay: 2000,
            disableOnInteraction: false,
        },
            pagination: {
            el: '.swiper-pagination',
        },
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["river-series-collections"]) return;
  try {
    
        const swiper = new Swiper('.swiper', {
            autoplay: {
                delay: 2000,
                disableOnInteraction: false,
            },
                pagination: {
                el: '.swiper-pagination',
            },
        });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solar_panel_bundle_1"] && !window.DesignMode) return;
  try {
    


window.addEventListener("scroll",()=>{
	let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    let offsetTop = document.querySelector('#searchBar').offsetTop;
    if (scrollTop > offsetTop) {
         document.querySelector('#searchBar').style.position="fixed";
         document.querySelector('#searchBar').style.top="0";
    } else {
         document.querySelector('#searchBar').style.position="";
         document.querySelector('#searchBar').style.top="";
    }
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solar_panel_bundle_4"] && !window.DesignMode) return;
  try {
    


var centeredSlides=false;
var spaceBetween=30;
var freeMode=true;
if (screen.width < 768) {

   centeredSlides=true;
   spaceBetween=20;
   freeMode = false;
  }

  console.log(Swiper)

 var h_feature_swiper = new Swiper('.h-feature-swiper-container', {
    centeredSlides:centeredSlides,
    slidesPerView: 'auto',
    spaceBetween: spaceBetween,
    freeMode: freeMode,
    autoplay:true,
    pagination: {
      clickable: true,
    },

  });





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solar_panel_bundle_5"] && !window.DesignMode) return;
  try {
    


$('.flipper').click(function(){



  if($(this).hasClass("rotate")){
　　　　　　　　$(this).removeClass("rotate").css('transform','rotateY(0deg)')
　　　　　}else{
　　　　　　$(this).addClass("rotate").css('transform','rotateY(180deg)')
　　　　　}
})



  } catch(e) { console.error(e); }
})();
})();
